import { AsyncThunkAction } from 'actions/actions.types'
import { handleRatingErrorAction } from 'actions/rating/photoRatingAction'
import { incrementLikedCounterAction } from 'actions/rating/promoAction'
import { showSettingsFilterPhotoAction } from 'actions/settings/showSettingsFilterPhotoAction'
import { Api6Error } from 'api/api.types'
import { photoLikeApi } from 'api/rating/likePhotoApi'
import { voteSourcePhotoRating } from 'common/constants'
import {
  ratingLegacyMatchPath,
  ratingPath,
} from 'components/page/RatingWave/Rating.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'

export const LIKE_PHOTO = 'LIKE_PHOTO' as const

export const likePhotoAction = (photoId: number) => ({
  type: LIKE_PHOTO,
  promise: () => photoLikeApi(photoId, voteSourcePhotoRating),
})

export type LikePhotoAction = ReturnType<typeof likePhotoAction>

export const likeWithHandlerErrorAction =
  (photoId: number): AsyncThunkAction =>
  async (dispatch) => {
    dispatch(showSettingsFilterPhotoAction())

    dispatch(incrementLikedCounterAction())

    const { result, error } = (await dispatch(
      likePhotoAction(photoId)
    )) as unknown as {
      result: { match: boolean }
      error: Api6Error
    }

    if (error?.code) {
      dispatch(handleRatingErrorAction(error))
    }

    if (result?.match) {
      dispatch(push(mergeAllUrls(ratingPath, ratingLegacyMatchPath)))
    }

    return Promise.resolve()
  }
